<template>
    <div>

        <headline>
            User
            <template slot="more">
                <user-create class="mr-2" @created="created"></user-create>
                <user-groups class="mr-2"></user-groups>
                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template>
                    Daten exportieren
                </button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

 
        <div>
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <li>
                    <a class="col-span-1 flex shadow-sm rounded-md" href="/admin/pages/rooms">
                        <div
                            class="flex-shrink-0 flex items-center justify-center w-16 bg-yellow-500 text-white text-sm font-medium rounded-l-md">
                            B
                        </div>
                        <div
                            class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div class="flex-1 px-4 py-2 text-sm truncate">
                                <span class="text-gray-900 font-medium hover:text-gray-600">Benutzer</span>
                                <p class="text-gray-500"> {{ users.length }} </p>
                            </div>
                            <div class="flex-shrink-0 pr-2">
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>

        <div class="mt-8">
            <tailwind-table
                :header_with_options="headers" 
                :has_filter=true
                @sort=sort>
                <template slot="button">
                    
                </template>
                <template slot="search">
                    <div>
                        <label class="block text-sm font-medium text-gray-700">
                            Suche
                        </label>
                        <div class="mt-1">
                            <input
                                v-model="search"
                                name="q"
                                class="form-input shadow-sm focus:ring-secondary focus:border-secondary block w-full sm:text-sm border-gray-300 rounded-md"
                                type="text"
                                aria-label="Searchbox"
                                placeholder="Suche"
                                autocomplete="off"
                                ref="qfield"
                            > 
                        </div>
                    </div>     
                </template>
                <template slot="filter">
                    <select-menu v-model="filter"
                    :text="filters.map(g => g.name)"
                    :values="filters.map(g => g.option)">
                        Filter
                    </select-menu>
                </template>
                <user
                    v-for="(user, i) in items"
                    :key="user.id"
                    :class="{'bg-gray-50': i%2, 'bg-white': !(i%2)}"
                    v-on:delete-user="remove(user)"
                    :user="user"
                    :search="search"
                    @reload="reload()"
                ></user>
            </tailwind-table>
        </div>
    </div>
</template>

<script>
import UserGroups from "./UserGroups";
import TailwindTable from "./UI/TailwindTable";
import User from "./User";
import ButtonSecondary from "./UI/ButtonSecondary";
import Headline from "./UI/Headline";
import Loading from "./UI/Loading.vue";
import UserCreate from "./User/UserCreate.vue";
import SelectMenu from "./UI/SelectMenu";

export default {
    name: "PeUsers",

    components: {UserCreate, Loading, Headline, ButtonSecondary, User, TailwindTable, UserGroups, SelectMenu},

    inject: ['admin'],

    data: function () {
        return {
            loading: false,
            filter: 'any',
            filters: [
                {name: 'Alle', option: 'any'},
                {name: 'Anbieter', option: 'owner'},
                {name: 'Nachfrager', option: 'tenants'},
            ],
            users: [],
            sortType: 'name',
            sortDesc: false,

            search: '',
        };
    },

    created() {
        this.reload();
    },

    computed: {
        headers() {
            let that = this;
            return [{name: 'Name', key: 'name'},
                    {name: 'Priorität', key: 'priority'},
                    {name: 'Gruppe', key: 'user_group.name'},
                    {name: 'Schreibtisch', key: 'desk.name'},
                    {name: 'Dabei seit', key: 'created_at'}]
                    .map(function(item){
                        item.sorted = item.key !== that.sortType ? null : (that.sortDesc ? 'desc' : 'asc')
                        return item;
                    })
        },

        items() {
            return this.itemsRaw.sort((a, b) => {
                let valA, valB;

                if (this.sortType === 'desk.name') {
                    valA = a.desk ? a.desk.name.toLowerCase() : null;
                    valB = b.desk ? b.desk.name.toLowerCase() : null;
                } else {
                    valA = a[this.sortType] ? a[this.sortType].toString().toLowerCase() : null;
                    valB = b[this.sortType] ? b[this.sortType].toString().toLowerCase() : null;
                }

                if (valA < valB) {
                    return this.sortDesc ? 1 : -1;
                }

                if (valA > valB) {
                    return this.sortDesc ? -1 : 1;
                }

                return 0;
            });
        },
        itemsRaw() {
            if (this.filter === 'owner') {
                return this.owners;
            }

            if (this.filter === 'tenants') {
                return this.tenants;
            }

            return this.owners
                .concat(this.tenants);

        },
        owners: function () {
            return this.users.filter(function (user) {
                return user.desk !== null;
            })
        },
        tenants: function () {
            return this.users.filter(function (user) {
                return user.desk === null;
            })
        }
    },
    methods: {
        created(email) {
            this.reload();
            this.search = email;
        },
        reload() {
            this.loading = true;
            window.axios
                .get('/admin/users')
                .then(result => {
                    this.users = result.data.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
        remove(user) {
            window.axios.post('/admin/users/' + user.id, {
                '_method': 'delete'
            })
                .then(() => {
                    this.users.splice(this.users.indexOf(user), 1);
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        ss(type) {
            if (this.sortType === type) {
                this.sortDesc = !this.sortDesc;
                return;
            }

            this.sortDesc = false;
            this.sortType = type;
        },
        download() {
            window.open('/admin/users/export');
        },
        sort(key) {
            if (this.sortType === key) {
                this.sortDesc = !this.sortDesc;
                return;
            }
            this.sortDesc = false;
            this.sortType = key;
        },
    }
}
</script>

<style scoped>

</style>
